// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-pml","label":"styles_label__r5k3S"};